import { ReactNode, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

// hooks
import { useAuth } from '../hooks';

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: ReactNode;
};

const AuthGuard = ({ children }: AuthGuardProps) => {
  const { isAuthenticated, hasAccessToNPD } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);
  const navigate = useNavigate();

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }

    window.location.replace(`${window.location.origin}/login?redirectUrl=${window.location.href}`);

    return null;
  }

  if (!hasAccessToNPD) {
    navigate('/401', { replace: true });
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};
export default AuthGuard;
